export default <R, T>(
  asyncFunction: (props: R) => T,
  retries = 2,
): ((props: R, retries?: number) => Promise<Awaited<T>>) => {
  const withRetry = async (props: R, n = retries): Promise<Awaited<T>> => {
    if (n < 1) {
      throw new Error('Retry cannot be less than 1');
    }
    try {
      return await asyncFunction(props);
    } catch (err) {
      if (n === 1) throw err;
      return withRetry(props, n - 1);
    }
  };

  return withRetry;
};
